import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTheme } from '@material-ui/core/styles';
import ReactApexChart from 'react-apexcharts';
import { modal_close_icon, modal_excel_icon } from '../../api/baseUrl';
import eye from '../../assets/media/icons/eye.svg';
import Download from '../../assets/media/icons/download.svg';
import { ColorPicker } from 'antd';
import Imageicon from '../../assets/media/icons/image.svg';
import ApexCharts from 'apexcharts';
import color_picker from '../../assets/media/icons/color_picker.svg';
// import { ApexOptions } from 'apexcharts';
import { valueCheckGlobal } from '../../GlobalFunctions';
import { formatMoney } from '../../GlobalFunctions';
import Linechart from '../../assets/media/icons/line-chart.svg';
import Barchart from '../../assets/media/icons/bar-chart.svg';
import { Popover } from '@mantine/core';

const ComparisonChartModal = (props) => {
  const theme = useTheme();

  let chartActive = props.chartActive;
  let setChartActive = props.setChartActive;
  let companyname = props.companyname;
  let label = props.label;
  let chartData = props.chartData;
  let slice = props.slice;
  let head = props.head;
  // console.log(123, head);

  let slicevalue = 10;
  if (slice) {
    slicevalue = 100;
  }
  let years = [];
  let value = [];
  //console.log(label);
  if (head !== undefined) {
    //////////Energy year Book Data
    years = head.slice(-10).map((d) => d['year']);
    value = head.slice(-10).map((d) => chartData[d['key']]);
  } else {
    value = chartData.slice(-slicevalue).map((d) => d['value']);
    years = chartData.slice(-slicevalue).map((d) => d['year']);
  }

  const [dataLabelShow, setDataLabelShow] = useState(true);
  const [openColorPicker, setOpenColorPicker] = useState(false);
  const [popoverOpened, setPopoverOpened] = useState(false);

  const [seriesType, setSeriesType] = useState('bar');
  const [strokeWidth, setStrokeWidth] = useState(2);

  const handleOpenColorPicker = (value) => {
    setOpenColorPicker(!value);
  };
  const handleSeriesColor = (e) => {
    // console.log(123, e.toHexString(), dataLabelShow);
    // handleDataLable(dataLabelShow);
    // handleDataLable(dataLabelShow);
    const width = seriesType === 'line' ? 2 : 0;
    const color = e.toHexString();
    const options = {
      fill: {
        colors: [color],
      },
      stroke: {
        colors: [color],
        show: true,
        curve: 'straight',
        width: width,
      },
      dataLabels: {
        enabled: dataLabelShow,
        position: 'top',
        //enabledOnSeries: arr,
      },
    };
    if (color !== false) {
      ApexCharts.exec('apexchart-example', 'updateOptions', options);
    }
  };

  var labelFormatter = function (value) {
    var val = Math.abs(value);
    if (val >= 1000000) {
      // val = val().toLocaleString();
      return (val = (val / 1000000).toFixed(1) + ' M');
    } else {
      val = val.toFixed(0);
    }
    //console.log(123, val);
    // val = val.toLocaleString();
    return formatMoney(val);
  };

  // const years = chartData.slice(-10).map((d) => d['year']);
  // const value = chartData.slice(-10).map((d) => d['value']);

  async function downloadSVG(chartId) {
    console.log(window.Apex._chartInstances);
    const chartInstance = window.Apex._chartInstances.find(
      (chart) => chart.id === chartId
    );
    console.log('chartInstance ', chartInstance);
    const base64 = await chartInstance.chart.dataURI();
    console.log('base 64', base64.imgURI);
    const downloadLink = document.createElement('a');
    downloadLink.href = base64.imgURI;
    downloadLink.download = label + '.png';

    // Add the anchor element to the document
    document.body.appendChild(downloadLink);

    downloadLink.click();

    document.body.removeChild(downloadLink);
  }

  const handleDataLable = (value) => {
    // handleChartType(value);
    // setOpenColorPicker(false);

    const width = seriesType === 'line' ? 2 : 0;
    setStrokeWidth(width);

    // console.log(123, width, value, dataLabelShow);
    setDataLabelShow(!value);
    // console.log(123, value, dataLabelShow);
    var lebel = {
      dataLabels: {
        enabled: !value,
        position: 'top',
        //enabledOnSeries: arr,
      },
      stroke: {
        show: true,
        curve: 'straight',
        width: width,
      },
    };
    ApexCharts.exec('apexchart-example', 'updateOptions', lebel);
  };

  const handleChartType = (type) => {
    // setOpenColorPicker(false);
    setSeriesType(type);

    const width = type === 'line' ? 2 : 0;
    // console.log(width);
    setStrokeWidth(width);

    const options = {
      stroke: {
        show: true,
        curve: 'straight',
        width: width,
      },
      dataLabels: {
        enabled: dataLabelShow,
        position: 'top',
        //enabledOnSeries: arr,
      },
    };
    ApexCharts.exec('apexchart-example', 'updateOptions', options);
  };

  const ApexOptions = {
    chart: {
      id: 'apexchart-example',
      height: 'auto',
      parentHeightOffset: 0,
      //foreColor: theme.palette.primary.main,
      type: seriesType,
      toolbar: {
        tools: {
          download:
            '<img src="' + Download + '" class="ico-download" width="20"> ',
          customIcons: [
            {
              icon: '<img src="' + eye + '" class="ico-download" width="20"> ',
              index: 0,
              title: '',
              class: 'custom-icon',
              click: () => {
                // handleChartType(seriesType);
                handleDataLable(dataLabelShow);
              },
            },
            {
              icon:
                '<img src="' +
                Imageicon +
                '" class="ico-download" width="20"> ',
              index: 0,
              title: '',
              class: 'custom-icon',
              click: () => {
                downloadSVG('apexchart-example');
              },
            },
            {
              icon:
                '<img src="' +
                color_picker +
                '" class="ico-download" width="20"> ',
              index: 0,
              title: '',
              class: 'custom-icon',
              click: () => {
                // handleDataLable(dataLabelShow);
                handleOpenColorPicker(openColorPicker);
                // setOpenColorPicker((openColorPicker) => !openColorPicker);
                handleChartType(seriesType);
              },
            },
            {
              icon:
                '<img src="' + Barchart + '" class="ico-download" width="20"> ',
              index: 0,
              title: '',
              class: 'custom-icon',

              click: () => {
                // exportDataAsCSV('apexchart-example')
                handleChartType('bar');
              },
            },
            {
              icon: `<img src="
                ${Linechart} 
                " class="ico-download" width="20"> `,
              index: 0,
              title: '',
              class: 'custom-icon',

              click: () => {
                // exportDataAsCSV('apexchart-example')
                handleChartType('line');
              },
            },
          ],
        },
        export: {
          svg: {
            filename: label,
          },
          csv: {
            filename: label,
          },
          png: {
            filename: label,
          },
        },
      },

      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: true,
      // position: 'top',
      // textAnchor: 'middle',
      offsetX: 0,
      offsetY: -10,
      hideOverflowingLabels: true,
      formatter: labelFormatter,
      style: {
        fontSize: '12px',
        fontWeight: 'light',
        posiiton: 'top',
        fontFamily: undefined,
        colors: ['#626768'],
      },
      background: {
        enabled: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return Number(value).toLocaleString('en-US');
        },
        /* formatter: function (value) {
          let val = Math.abs(value);

          if (val >= 500 && val < 500) {
            val = (val / 1000).toFixed(2) + ' b';
          } else if (val >= 1000) {
            val = (val / 1000).toFixed(2) + ' b';
          } else {
            val = val;
          }

          return val;
        } */
      },
      decimalsInFloat: 2,
    },

    xaxis: {
      categories: years,
      labels: {
        rotate: -270,
      },
      title: {
        text: label,
        // align: 'center',
        // margin: 40,
        offsetX: 0,
        offsetY: -280,
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          posiiton: 'top',
          fontFamily: undefined,
          color: '#000',
        },
      },
    },
    legend: {
      width: 400,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        // top: -10,
        // right: -10,
        bottom: -20,
        // left: -10,
      },
    },
    stroke: {
      width: 0,
      curve: 'straight',
    },
    series: [
      {
        name: '',
        type: seriesType,
        data: value,
      },
    ],
  };

  return (
    <>
      <Modal
        style={styles.modalBackdrop}
        className="table-modal session-modal"
        show={chartActive ? true : false}
        centered
      >
        <Modal.Header style={styles.modalHeader}>
          <Modal.Title
            style={styles.modalTitle}
            className="text-left d-inline-block w-100"
          >
            {label}
            <span
              style={styles.close}
              onClick={() => {
                setChartActive(false);
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: modal_close_icon }} />
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={styles.modalBody}>
          <ColorPicker
            size="small"
            open={openColorPicker}
            onChange={(e) => {
              handleSeriesColor(e);
            }}
            presets={[
              {
                label: 'Recommended',
                colors: [
                  '#002060',
                  '#7F7F7F',
                  '#FADB14',
                  '#8BBB11',
                  '#52C41A',
                  '#13A8A8',
                  '#1677FF',
                  '#2F54EB',
                  '#722ED1',
                  '#EB2F96',
                ],
              },
            ]}
          >
            <div></div>
          </ColorPicker>
          <div>{/*label*/} </div>
          <ReactApexChart options={ApexOptions} series={ApexOptions.series} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ComparisonChartModal;

const styles = {
  modalBackdrop: {
    zIndex: '999999',
    borderRadius: '20px',
  },
  modalHeader: {
    padding: '15px 25px',
    letterSpacing: '0.3px',
    fontWeight: '700',
    color: '#3d3d3d',
    borderBottom: 'var(--light-border)',
  },
  modalTitle: {
    fontWeight: '700',
    color: '#3969D5',
    fontSize: '18px',
    // textTransform: 'capitalize',
  },
  modalBody: {
    background: '#fff',
    // padding: '10px 15px 0px',
  },
  close: {
    cursor: 'pointer',
    float: 'right',
    color: '#3d3d3d',
  },
  chart: {
    cursor: 'pointer',
    float: 'left',
    posiiton: 'absolute',
    padding: '0px 10px 0 0px',
  },
  excel: {
    cursor: 'pointer',
    float: 'right',
  },
  sessionAlertContent: {
    position: 'relative',
  },
  para: {
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '400',
  },
  iconSpan: {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '50px',
    color: '#ffff',
    margin: '0',
  },
  buttonOK: {
    position: 'absolute',
    right: '15px',
    width: '70px',
    border: 'none',
    background: '#3969d5',
    textTransform: 'uppercase',
    color: '#fff',
    fontWeight: '600',
    borderRadius: '7px',
    padding: '4px 10px',
  },
};
